var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-loading',_vm._b({staticClass:"btn btn-primary",style:({backgroundColor: _vm.color, borderColor: _vm.color, color: _vm.$invertColor(_vm.color)}),on:{"click":_vm.onClick}},'button-loading',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }